import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDividerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { NgxMaskModule } from 'ngx-mask';

import { FieldPhoneNumberInputModule } from '@ui/field-phone-number-input';
import { UiErrorsModule } from '@ui/ui-errors';

import { PhoneCardComponent } from './components/phone-card/phone-card.component';
import { ConfirmationCodeComponent } from './components/confirmation-code/confirmation-code.component';
import { LoginConfirmationCodeComponent } from './pages/login-confirmation-code/login-confirmation-code.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthComponent } from './auth.component';
import { RegistrationConfirmationCodeComponent } from './pages/registration-confirmation-code/registration-confirmation-code.component';
import { RegistrationPhoneComponent } from './pages/registration-phone/registration-phone.component';
import { RegistrationComponent } from './pages/registration/registration.component';
import {RecoveryPasswordConfirmationCodeComponent} from './pages/recovery-password-confirmation-code/recovery-password-confirmation-code.component';
import {RecoveryPasswordComponent} from './pages/recovery-password/recovery-password.component';
import {RecoveryPasswordPhoneComponent} from './pages/recovery-password-phone/recovery-password-phone.component';
import {PasswordComponent} from './components/password/password.component';

@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    LoginConfirmationCodeComponent,
    RegistrationComponent,
    RegistrationPhoneComponent,
    RegistrationConfirmationCodeComponent,
    PhoneCardComponent,
    ConfirmationCodeComponent,
    RecoveryPasswordConfirmationCodeComponent,
    RecoveryPasswordComponent,
    RecoveryPasswordPhoneComponent,
    PasswordComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FieldPhoneNumberInputModule,
    UiErrorsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
    Angular2PromiseButtonModule.forRoot(),

    /* mat modules*/
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule
    /* end mat modules */
  ],
  providers: [],
  exports: []
})
export class AuthModule {
}

